import jsPDF from "jspdf";

const M = 40;
const COLOR_BG = [9, 10, 11];
const COLOR_VOLT = [194, 255, 5];
const COLOR_FG = [243, 244, 246];
const COLOR_MUTED = [60, 60, 60];
const COLOR_FOOTER = [120, 120, 120];
const COLOR_SECONDARY = [20, 21, 23];

function drawHeader(doc, plan, W) {
  doc.setFillColor(...COLOR_BG);
  doc.rect(0, 0, W, 90, "F");
  doc.setFillColor(...COLOR_VOLT);
  doc.rect(M, 30, 30, 30, "F");
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("TP", M + 4, 53);
  doc.setTextColor(...COLOR_FG);
  doc.setFontSize(10);
  doc.text("// TACTICAL PROGRESSION  //  FM 7-22 H2F", M + 45, 38);
  doc.setFontSize(20);
  doc.text((plan.name || "Plan").toUpperCase(), M + 45, 60);
}

function drawMeta(doc, plan, y) {
  doc.setTextColor(...COLOR_MUTED);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const parts = [
    `TYPE: ${plan.type?.toUpperCase() || ""}`,
    plan.goal ? `GOAL: ${plan.goal}` : null,
    plan.level ? `LEVEL: ${plan.level}` : null,
    `WEEKS: ${plan.weeks?.length || 0}`,
  ].filter(Boolean);
  doc.text(parts.join("    |    "), M, y);
  return y + 22;
}

function drawWeekHeader(doc, w, y, W) {
  doc.setFillColor(...COLOR_SECONDARY);
  doc.rect(M, y - 14, W - 2 * M, 22, "F");
  doc.setTextColor(...COLOR_VOLT);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text(`WEEK ${w.week_index}${w.intent ? `  //  ${w.intent}` : ""}`, M + 8, y);
}

function formatExerciseLine(ex, exMap) {
  const name = exMap[ex.exercise_id]?.name || ex.exercise_id;
  const detail = ex.sets ? `${ex.sets}x${ex.reps || ""}` : (ex.reps || "");
  const wt = ex.weight ? `  @  ${ex.weight}` : "";
  const notes = ex.notes ? `   (${ex.notes})` : "";
  return `  • ${name}${detail ? "  —  " + detail : ""}${wt}${notes}`;
}

function drawDay(doc, d, y, W, ensureSpace, exMap) {
  ensureSpace(40);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(`DAY ${d.day} — ${d.focus || "Train"}`, M, y);
  y += 14;
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...COLOR_MUTED);
  if (!d.exercises || d.exercises.length === 0) {
    doc.text("  —", M, y);
    return y + 14 + 4;
  }
  for (const ex of d.exercises) {
    ensureSpace(14);
    const wrapped = doc.splitTextToSize(formatExerciseLine(ex, exMap), W - 2 * M);
    for (const ln of wrapped) {
      ensureSpace(14);
      doc.text(ln, M, y);
      y += 14;
    }
  }
  return y + 4;
}

function drawFooter(doc, H) {
  const pages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(...COLOR_FOOTER);
    doc.text(`Tactical Progression  //  Page ${i} of ${pages}`, M, H - 20);
  }
}

export function exportPlanToPDF(plan, exMap = {}) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();

  drawHeader(doc, plan, W);
  let y = drawMeta(doc, plan, 110);

  const ensureSpace = (need) => {
    if (y + need > H - M) { doc.addPage(); y = M; }
  };

  for (const w of plan.weeks || []) {
    ensureSpace(40);
    drawWeekHeader(doc, w, y, W);
    y += 22;
    for (const d of w.days || []) {
      y = drawDay(doc, d, y, W, ensureSpace, exMap);
    }
    y += 6;
  }

  drawFooter(doc, H);
  doc.save(`${(plan.name || "plan").replace(/[^a-z0-9]+/gi, "_")}.pdf`);
}
